  <div class="z-10 w-full flex justify-center mt-4" [style.marginBottom]="mobile ? '2.5rem' : '6rem'"  id="plan-container">

    <div class="background-image background-cover z-50 text-center w-full  md:text-xl text-xs">
      <div class="overflow-y-auto overflow-x-hidden h-9/12">
        <ng-container *ngFor="let plan of plans; let i = index">
        <div class="w-full hpx-50 m-1 individual-cards">

            <div class="h-full flex flex-col justify-center overflow-hidden box flex justify-center ml-6 mr-6 mb-2"
                 style="border-radius: 5px; border: 1px solid gray; position: relative;" (click)="setSelected(plan)"
                 [id]="plan['vPlanID']"
                 [ngClass]="selected != undefined ? plan.vPlanID == selected.vPlanID ? 'selected' : '' : ''">
              <div class="justify-center items-center side front bg-cover h-full" id="paymentTabFront" #paymentTabFront>
                <div class="flex h-full">
                  <div class="w-full h-full pl-2 justify-start items-start" style="background-color: #dddddd; text-align: left;">
                    <div *ngIf="plan.numberOfInstallments == 1">
                      <div class="w-2/3 h-1/2 justify-start items-start text-lg">
                        <p><b>{{ plan.costInfo.currency }} {{ (plan.costInfo.firstInstallment.amount / 100).toFixed(2) }}</b></p>
                      </div>
                    </div>
                    <div *ngIf="plan.numberOfInstallments != 1">
                      <div class="w-2/3 h-1/2 justify-start items-start text-lg">
                        <p><b>{{ plan.costInfo.currency }} {{ (plan.costInfo.firstInstallment.amount / 100).toFixed(2) }}</b>/month  (APR: {{ plan.costInfo.annualPercentageRate }}%)</p>
                      </div>
                      <div class="w-2/3 h-1/2 pl-2 justify-start items-start  md:text-sm text-xs" *ngIf="plan.numberOfInstallments != 1">
                        <p>Total Fee: {{ plan.costInfo.currency + " " + (plan.costInfo.totalFees / 100).toFixed(2) }} | Total: {{ plan.costInfo.currency + " " + (plan.costInfo.totalPlanCost / 100).toFixed(2) }}</p>
                      </div>
                    </div>
                    <div class="w-1/4 h-full pb-1 justify-start items-start pb-1" style="position: absolute; top: 0px; right: 0px; padding: 2px; border-radius: 5px; display: flex;" [ngStyle]="{'background-color': headerColor}">
                      <div class="flex w-3/4 h-full pl-6 justify-left items-center">
                        <p>{{ plan.numberOfInstallments == 1 ? 'Pay in Full' : "Pay in " + plan.numberOfInstallments}}</p>
                      </div>
                      <div class="flex w-1/4 h-full justify-end items-center pr-4">
                        <img src="../../assets/vis/VisaInstallmentsSymbol.svg" style="height: 60%; width: 60%;"  *ngIf="i !== 0">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="flex items-center mr-4 ml-6 pt-3 pb-3 h-1/12">
        <hr class="border-t border-gray-300 flex-grow mr-4">
        <img src="../../assets/vis/Logo/1line/blue/IEBVlockup_1line_blu_UK_012922.svg" style="height: 35%; width: 35%;">
        <hr class="border-t border-gray-300 flex-grow ml-4">
      </div>
      <div *ngIf="terms" (click)="toggleExpanded()" class="background-image background-cover z-50 text-center w-full overflow-y-auto overflow-x-hidden h-2/12">
        <h1 class="w-full text-sm font-bold">
          <input type="checkbox" id="accept-terms" [(ngModel)]="isAccepted">
          Terms & Conditions
        </h1>

        <p class="justify-center text-xs">
          {{ isExpanded ? terms : (terms | slice:0:50) }}
          {{ isExpanded ? '' : ' ...' }}
        </p>
      </div>

    </div>

  </div>
  <div class="w-full flex flex-col justify-center absolute" [ngStyle]="{'bottom': '10%'}" >
    <div>
      <div class="flex justify-center" [ngClass]="mobile ? 'flex-col' : 'flex-row-reverse'">
        <div class="flex justify-center items-center flex-col confirm-container mt-2" [ngClass]="mobile ? 'mb-2' : 'mb-4'" *ngIf="!paymentConfirm">
          <button [disabled]="loading || selected === undefined || selected === null || !isAccepted"
                  class="text-xl text-white font-medium border-solid rounded-lg continue-button pt-2 pb-2 max-w-225 wpx-225 flex justify-center"
                  [ngStyle]="{'background-color': headerColor}"
                  (click)="continueButton()">
            <span *ngIf="!loading">{{ 'CONTINUE' }} </span>
            <mat-spinner
              *ngIf="loading"
              class="loading-spinner mb-1 mt-1"
              [color]="color"
              [diameter]="diameterContinue"
            >
            </mat-spinner>
          </button>
        </div>
        <div class="flex justify-center items-center flex-col confirm-container mt-2 mb-4" [ngClass]="mobile ? 'mr-0' : 'mr-4'" *ngIf="!paymentConfirm">
          <button [disabled]="loading" class="text-xl font-medium rounded-lg continue-button px-16 flex items-center" [ngStyle]="{'height': '48px', 'color': 'black',  'border': '3px solid ' + headerColor }" mat-button (click)="cancelTransaction()">
            <p class="p-0 m-0" *ngIf="!transactionCancelled">{{ 'CANCEL' }}</p>
            <mat-spinner
              *ngIf="transactionCancelled"
              class="loading-spinner mb-4 mt-4"
              [color]="color"
              [diameter]="diameterColour"
            >
            </mat-spinner>
          </button>
        </div>
      </div>
    </div>

    <div class="w-100 flex justify-center text-center px-4 mat-typography" style="padding-bottom: 5px;">
      <span class="text-xs">You may be redirected to your bank’s secure site to authenticate yourself before making the payment.</span>
    </div>

  </div>
